// extracted by mini-css-extract-plugin
module.exports = {"section":"page-section_section__7Zyr2"};